import { ClientService } from '../shared/api/ClientService';
import authService from '../components/Auth/AuthorizeService';

const { APIClient, GetPreSelectedAppointmentDateAPIClient } = ClientService;

// Wait until authentication is ready (token available) before allowing any API call to go out.
async function waitForAuthReady(): Promise<void> {
  const anyAuth: any = authService as any;
  if (typeof anyAuth.whenReady === 'function') {
    await anyAuth.whenReady();
    return;
  }

  const deadline = Date.now() + 15000; // 15s cap to avoid hanging forever
  // eslint-disable-next-line no-constant-condition
  while (true) {
    try {
      const token = await authService.getAccessToken();
      if (token) return; // ready
    } catch {
      // ignore transient errors during provider startup
    }
    if (Date.now() > deadline) return; // give up; proceed without blocking
    await new Promise((r) => setTimeout(r, 150));
  }
}

// Central guarded fetch for all NSwag clients
const guardedFetch: typeof window.fetch = async (input, init) => {
  (window as any).__authLoading = true;

  await waitForAuthReady();

  (window as any).__authLoading = false;

  let res = await window.fetch(input, init);

  // Optional: one-time retry on 401 after silent token acquire/refresh, if available
  const anyAuth: any = authService as any;
  if (res.status === 401 && typeof anyAuth.refreshOrAcquireToken === 'function') {
    try {
      await anyAuth.refreshOrAcquireToken();
      res = await window.fetch(input, init);
    } catch {
      // ignore and return the 401 response
    }
  }

  return res;
};

const API = new APIClient(process.env.REACT_APP_BASE_URL, { fetch: guardedFetch });
const GetPreSelectedAppointmentDateClientAPI = new GetPreSelectedAppointmentDateAPIClient(
  process.env.REACT_APP_BASE_URL,
  { fetch: guardedFetch }
);

export default API;
export { GetPreSelectedAppointmentDateClientAPI };
